import * as io from "io-ts";

export const MaybeStringResolver = io.union([io.string, io.null, io.undefined]);

export const MaybeNumberResolver = io.union([io.number, io.null, io.undefined]);

export const MaybeStringArrayResolver = io.union([io.array(MaybeStringResolver), io.null, io.undefined]);

export const MaybeNumberArrayResolver = io.union([io.array(MaybeNumberResolver), io.null, io.undefined]);
